import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  selectedLang = new BehaviorSubject<string>(
    localStorage.getItem('lang') || '' // No default - user must select
  );

  constructor(private translate: TranslateService) {
    const savedLang = this.selectedLang.value;
    if (savedLang) {
      this.translate.setDefaultLang(savedLang);
      this.translate.use(savedLang);
    }
    // If no saved language, don't set any default
  }

  setLanguage(lang: string) {
    this.selectedLang.next(lang);
    localStorage.setItem('lang', lang);
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
  }

  /**
   * Check if user has selected a language
   * @returns boolean indicating if language is selected
   */
  hasLanguageSelected(): boolean {
    return !!this.selectedLang.value;
  }

  /**
   * Get available language options
   * @returns Array of language options
   */
  getAvailableLanguages() {
    return [
      { code: 'en', name: 'English', flag: '🇺🇸' },
      { code: 'fr', name: 'French', flag: '🇫🇷' },
      { code: 'de', name: 'German', flag: '🇩🇪' },
      { code: 'it', name: 'Italian', flag: '🇮��' },
    ];
  }
}
